import { AppState } from '../../init/rootReducer';
import { VendorProfileState } from './slices';

// eslint-disable-next-line import/prefer-default-export
export const getVendorProfileState = (state: AppState): VendorProfileState =>
  state.containers.vendorProfile;
